import { createAction } from 'redux-actions';
import { timeFormat } from 'd3-time-format';

const requestPayloadCreator = ({ id }) => id;
const metaCreator = m => m;

export const secondTimeFormat = timeFormat('%H:%M:%S');

export const requestAction =
  createAction('REQUEST_DATA', requestPayloadCreator, metaCreator);

export const cachedRequestAction =
  createAction('REQUEST_DATA_FOUND_IN_CACHE', requestPayloadCreator, metaCreator);

export const rejectedRequestAction =
  createAction('REQUEST_CANCELLED', requestPayloadCreator, metaCreator);

export const checkForCachedDataAction = (action, dispatch) => (
  new Promise((resolve, reject) => {
    try {
      const result = dispatch(action);
      resolve(result);
    } catch (error) {
      reject(new Error(error.message));
    }
  })
);
